import React, { useMemo, useState } from 'react';
import filter from 'lodash/filter';
import find from 'lodash/find';
import size from 'lodash/size';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { CommonTabs } from '../../CommonTabs';
import { IDS } from '../../../../constants/ids';
import SelectableList from '../../List/SelectableList';
import { SEARCH_TABS } from '../../../../constants/props';
import EmptySearchResults from '../EmptySearchResults';
import styles from './index.styl';

const TABS = [
  {
    label: 'general.search.tabs.providers',
    id: IDS.SEARCH_TABS.PROVIDER,
    tab: SEARCH_TABS.PROVIDERS,
  },
  {
    label: 'general.search.tabs.people',
    id: IDS.SEARCH_TABS.PEOPLE,
    tab: SEARCH_TABS.PEOPLE,
  },
  {
    label: 'general.search.tabs.teams',
    id: IDS.SEARCH_TABS.TEAMS,
    tab: SEARCH_TABS.TEAMS,
    query: 'team_search',
  },
];

const SelectableListWithTabs = ({
  withTabs,
  users,
  onTabSelect,
  onSelect,
  loading,
  succeed,
  defaultIcon,
  defaultState,
  emptyState,
}) => {
  const [activeTab, setActiveTab] = useState(withTabs ? withTabs[0] : null);
  const tabsOptions = useTabs(withTabs);

  const handleTabSelect = tab => {
    setActiveTab(tab);
    onTabSelect(tab);
  };

  const getContent = () => (
    <If condition={size(users)}>
      <SelectableList
        white={Boolean(withTabs)}
        items={users}
        onSelect={onSelect}
        className="overflow-auto h-100"
        withCounter
      />
      <Else />
      <EmptySearchResults
        withTabs={Boolean(withTabs)}
        succeed={succeed}
        loading={loading}
        defaultState={defaultState}
        defaultIcon={defaultIcon}
        emptyState={emptyState}
      />
    </If>
  );

  return (
    <div styleName="root">
      <If condition={withTabs}>
        <CommonTabs
          onTabSelect={handleTabSelect}
          activeTab={activeTab}
          tabList={tabsOptions}
          renderContent={getContent}
          className="w-100 h-100 flex flex-column"
        />
        <Else />
        {getContent()}
      </If>
    </div>
  );
};

SelectableListWithTabs.propTypes = {
  withTabs: PropTypes.array,
  users: PropTypes.array,
  onTabSelect: PropTypes.func,
  onSelect: PropTypes.func,
  loading: PropTypes.bool,
  succeed: PropTypes.bool,
  defaultIcon: PropTypes.string,
  defaultState: PropTypes.string.isRequired,
  emptyState: PropTypes.string.isRequired,
};

export default CSSModules(SelectableListWithTabs, styles, {
  allowMultiple: true,
});

function useTabs(tabs) {
  return useMemo(() => {
    return filter(TABS, item => !!find(tabs, tab => tab === item.tab));
  }, [tabs]);
}



// WEBPACK FOOTER //
// ./src/components/common/SearchDialog/SelectableListWithTabs/index.jsx